import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Imoveis from './pages/Imoveis'
import Vendas from './pages/Vendas'
import Construtoras from './pages/Construtoras'
import Proprietarios from './pages/Proprietarios'
import MeuDriver from './pages/MeuDriver'
import SharedDrive from './pages/SharedDrive'
import Afiliados from './pages/Afiliados'
import Cadastro from './pages/Cadastro'
import Perfil from './pages/Perfil'
import Assinatura from './pages/Assinatura'
import Planos from './pages/Planos'
import Assinar from './pages/Assinar'
import FormaPagamento from './pages/FormaPagamento'
import CartaoLinkAguardando from './pages/CartaoLinkAguardando'
import { ControleAssinaturas } from './pages/ControleAssinaturas'
import Cursos from './pages/Cursos'
import CursoDetalhes from './pages/CursoDetalhes'
import AdminCursos from './pages/AdminCursos'
import AdminModulos from './pages/AdminModulos'
import AdminAulas from './pages/AdminAulas'
import AdminCupons from './pages/AdminCupons'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'
import AdminUsuarios from './pages/AdminUsuarios'
import AdminImoveis from './pages/AdminImoveis'
import AdminPlanos from './pages/AdminPlanos'
import AdminNotificacoes from './pages/AdminNotificacoes'
import AdminConfiguracoes from './pages/AdminConfiguracoes'
import CursosDebug from './pages/CursosDebug'
import CursosDebugDetalhado from './pages/CursosDebugDetalhado'
import DashboardLayout from './components/DashboardLayout'
import AdminLayout from './components/AdminLayout'
import AdminProtectedRoute from './components/AdminProtectedRoute'
import TrialProtectedRoute from './components/TrialProtectedRoute'
import { ModalProvider, useModal } from './contexts/ModalContext'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { AdminAuthProvider } from './contexts/AdminAuthContext'

// Componente de Rota Protegida
function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { user, loading } = useAuth()
    const { isModalOpen } = useModal()

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
                    <p className="mt-2 text-gray-600">Carregando...</p>
                </div>
            </div>
        )
    }

    if (!user) {
        return <Navigate to="/login" replace />
    }

    return <DashboardLayout isModalOpen={isModalOpen}>{children}</DashboardLayout>
}

// Componente Wrapper para Rotas Admin
function AdminRoute({ children }: { children: React.ReactNode }) {
    return (
        <AdminProtectedRoute>
            <AdminLayout>
                {children}
            </AdminLayout>
        </AdminProtectedRoute>
    )
}

// Componente Principal
function App() {
    return (
        <AuthProvider>
            <AdminAuthProvider>
                <ModalProvider>
                    <Router>
                        <Routes>
                            {/* Rotas Públicas */}
                            <Route path="/login" element={<Login />} />
                            <Route path="/cadastro" element={<Cadastro />} />
                            <Route path="/planos" element={<Planos />} />
                            <Route path="/assinar" element={<Assinar />} />
                            <Route path="/pagamento" element={<FormaPagamento />} />
                            <Route path="/pagamento/cartao/aguardando" element={<CartaoLinkAguardando />} />

                            {/* Rota de Login Admin */}
                            <Route path="/admin/login" element={<AdminLogin />} />

                            {/* Rotas Admin Protegidas */}
                            <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                            <Route path="/admin/usuarios" element={<AdminRoute><AdminUsuarios /></AdminRoute>} />
                            <Route path="/admin/cursos" element={<AdminRoute><AdminCursos /></AdminRoute>} />
                            <Route path="/admin/cursos/:id/modulos" element={<AdminRoute><AdminModulos /></AdminRoute>} />
                            <Route path="/admin/cursos/:cursoId/modulos/:moduloId/aulas" element={<AdminRoute><AdminAulas /></AdminRoute>} />
                            <Route path="/admin/cupons" element={<AdminRoute><AdminCupons /></AdminRoute>} />
                            <Route path="/admin/vendas" element={<AdminRoute><Vendas /></AdminRoute>} />
                            <Route path="/admin/imoveis" element={<AdminRoute><AdminImoveis /></AdminRoute>} />
                            <Route path="/admin/assinaturas" element={<AdminRoute><ControleAssinaturas /></AdminRoute>} />
                            <Route path="/admin/planos" element={<AdminRoute><AdminPlanos /></AdminRoute>} />
                            <Route path="/admin/notificacoes" element={<AdminRoute><AdminNotificacoes /></AdminRoute>} />
                            <Route path="/admin/configuracoes" element={<AdminRoute><AdminConfiguracoes /></AdminRoute>} />

                            {/* Rotas de Usuário Protegidas */}
                            <Route path="/cursos" element={
                                <ProtectedRoute>
                                    <TrialProtectedRoute recursoNome="Cursos">
                                        <Cursos />
                                    </TrialProtectedRoute>
                                </ProtectedRoute>
                            } />
                            <Route path="/cursos-debug" element={<ProtectedRoute><CursosDebug /></ProtectedRoute>} />
                            <Route path="/cursos-debug-detalhado" element={<ProtectedRoute><CursosDebugDetalhado /></ProtectedRoute>} />
                            <Route path="/cursos/:id" element={
                                <ProtectedRoute>
                                    <TrialProtectedRoute recursoNome="Cursos">
                                        <CursoDetalhes />
                                    </TrialProtectedRoute>
                                </ProtectedRoute>
                            } />
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/imoveis"
                                element={
                                    <ProtectedRoute>
                                        <Imoveis />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/vendas"
                                element={
                                    <ProtectedRoute>
                                        <Vendas />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/construtoras"
                                element={
                                    <ProtectedRoute>
                                        <Construtoras />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/proprietarios"
                                element={
                                    <ProtectedRoute>
                                        <Proprietarios />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/meu-driver"
                                element={
                                    <ProtectedRoute>
                                        <TrialProtectedRoute recursoNome="Meu Driver">
                                            <MeuDriver />
                                        </TrialProtectedRoute>
                                    </ProtectedRoute>
                                }
                            />
                            {/* Rota pública de compartilhamento - não requer login */}
                            <Route path="/drive/shared/:token" element={<SharedDrive />} />
                            <Route
                                path="/afiliados"
                                element={
                                    <ProtectedRoute>
                                        <TrialProtectedRoute recursoNome="Afiliados" recursoChave="afiliados">
                                            <Afiliados />
                                        </TrialProtectedRoute>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/perfil"
                                element={
                                    <ProtectedRoute>
                                        <Perfil />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/assinatura"
                                element={
                                    <ProtectedRoute>
                                        <Assinatura />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/relatorios" element={<ProtectedRoute><div className="p-6"><h1 className="text-2xl font-bold">Relatórios - Em Desenvolvimento</h1></div></ProtectedRoute>} />
                            <Route path="/calendario" element={<ProtectedRoute><div className="p-6"><h1 className="text-2xl font-bold">Calendário - Em Desenvolvimento</h1></div></ProtectedRoute>} />
                            <Route path="/mensagens" element={<ProtectedRoute><div className="p-6"><h1 className="text-2xl font-bold">Mensagens - Em Desenvolvimento</h1></div></ProtectedRoute>} />
                            <Route path="/busca" element={<ProtectedRoute><div className="p-6"><h1 className="text-2xl font-bold">Busca Avançada - Em Desenvolvimento</h1></div></ProtectedRoute>} />
                        </Routes>
                    </Router>
                </ModalProvider>
            </AdminAuthProvider>
        </AuthProvider>
    )
}

export default App
